import CheckmarkFilled from '@shared/assets/icons/checkmark/filled.svg';
import { ButtonView, View } from '@shared/components/View';
import { API } from '@shared/types/api';
import { getTestId } from '@shared/util/getTestId';
import classNames from './ReactionPicker.module.css';
import { MBReaction, reactions } from './types';

export interface ReactionPickerProps {
  // Callback for when pressing a reaction
  onToggleReaction: (reaction: API.ReactionType, add: boolean) => void;

  // List of selected reaction types. Eg the reactions the user has already reacted with
  selected: API.ReactionType[];

  testID?: string;
}

/*
    This component lets the user pick a reaction. This is shown in a tooltip
    form when a reaction button is pressed.
*/
export function ReactionPicker({ onToggleReaction, selected, testID }: ReactionPickerProps) {
  return (
    <View className={classNames.reactionPicker} testID={testID}>
      {reactions.map(reaction => (
        <ReactionPickerItem
          key={reaction.type}
          isSelected={selected.includes(reaction.type)}
          reaction={reaction}
          onToggleReaction={onToggleReaction}
        />
      ))}
    </View>
  );
}

interface ReactionPickerItemProps extends Pick<ReactionPickerProps, 'onToggleReaction'> {
  isSelected: boolean;
  reaction: MBReaction;
}

function ReactionPickerItem({ reaction, onToggleReaction, isSelected }: ReactionPickerItemProps) {
  const onPress = () => onToggleReaction(reaction.type, !isSelected);
  const testID = getTestId('reaction-picker-item', reaction.emoji);

  return (
    <ButtonView onClick={onPress} testID={testID} className={classNames.item}>
      {reaction.emoji}
      {isSelected && (
        <div className={classNames.selectedIcon}>
          <CheckmarkFilled />
        </div>
      )}
    </ButtonView>
  );
}
